import React from "react";
import styled from "styled-components";
import { Select as AntSelect, Tooltip } from "antd";

import { blue } from "utils/constants/colors";
import { InfoCircleOutlined } from "@ant-design/icons";

//

const Select = styled(AntSelect)`
  .ant-select-arrow.ant-select-arrow-loading {
    color: ${blue};
  }

  .ant-select-selection-item > span {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const LabelOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .anticon.anticon-info-circle {
    margin-left: 11px;
  }
`;

export default function SelectWithOptions({ options = [], ...rest }) {
  function renderOption(option) {
    return (
      <Select.Option
        key={option.value}
        value={option.value}
        label={<span title={option.label}>{option.label}</span>}
      >
        <LabelOption>
          <Tooltip title={option.label} placement="right">
            <span>{option.label}</span>
          </Tooltip>{" "}
          {option.description && (
            <Tooltip title={option.description} placement="right">
              <InfoCircleOutlined />
            </Tooltip>
          )}
        </LabelOption>
      </Select.Option>
    );
  }

  return (
    <Select {...rest} optionLabelProp="label">
      {options.map(renderOption)}
    </Select>
  );
}
